import Vue from "vue";
import Router from "vue-router";

import authGuard from "./auth-guard";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/ripuaria",
      redirect: "/",
    },
    {
      path: "/",
      name: "Korpodesk",
      component: () => import("../main/Home.vue"),
      hash: "main",
      beforeEnter: authGuard,
      meta: {
        title: "Home",
      },
    },
    {
      path: "/sommerfest",
      name: "Sommerfest",
      component: () => import("../main/sommerfest.vue"),
      beforeEnter: authGuard,
      meta: {
        title: "Sommerfest",
      },
    },
    {
      path: "/event/:id",
      name: "Veranstaltung",
      component: () => import("../main/Veranstaltung.vue"),
      beforeEnter: authGuard,
      meta: {
        title: "Veranstaltung",
      },
    },
    {
      path: "/ripuarentage",
      name: "Ripuarentage",
      component: () => import("../main/ripuarentage.vue"),
      beforeEnter: authGuard,
      meta: {
        title: "Ripuarentage",
      },
    },
    {
      path: "/veranstaltungen",
      name: "Veranstaltungen",
      component: () => import("../main/Veranstaltungen.vue"),
      beforeEnter: authGuard,
      meta: {
        title: "Veranstaltungen",
      },
    },
    {
      path: "/bbrbbr",
      name: "Mitglieder",
      component: () => import("../main/BbrBbr.vue"),
      beforeEnter: authGuard,
      meta: {
        title: "Mitglieder",
      },
    },
    {
      path: "/rechnungen",
      name: "Rechnungen",
      props: true,
      component: () => import("../main/Rechnungen.vue"),
      beforeEnter: authGuard,
      meta: {
        title: "Rechnungen",
      },
    },
    {
      path: "/daten",
      name: "Daten",
      component: () => import("../main/Daten.vue"),
      beforeEnter: authGuard,
      meta: {
        title: "Daten",
      },
    },
    {
      path: "/download",
      name: "Download",
      component: () => import("../main/Download.vue"),
      beforeEnter: authGuard,
      meta: {
        title: "Download",
      },
    },
    {
      path: "/semester",
      name: "Semester",
      component: () => import("../main/Semester.vue"),
      beforeEnter: authGuard,
      meta: {
        title: "Semester",
      },
    },
    {
      path: "/modul/:seite/:modul",
      name: "Modul",
      props: true,
      component: () => import("../main/ModulSeite.vue"),
      beforeEnter: authGuard,
      meta: {
        key: "modul",
        title: (route) => `${route.params.seite}`,
      },
    },
    {
      path: "/stammbaum/home",
      name: "Stammbaum",
      props: true,
      component: () => import("../components/Stammbaum/Uebersicht.vue"),
      beforeEnter: authGuard,
      meta: {
        title: "Stammbaum",
      },
    },
    {
      path: "/stammbaum/daten",
      name: "Stammbaum - Daten",
      props: true,
      component: () => import("../components/Stammbaum/Daten.vue"),
      beforeEnter: authGuard,
      meta: {
        title: "Stammbaum - Daten",
      },
    },
    {
      path: "/registrieren",
      name: "Registrieren",
      component: () => import("../components/User/Signin.vue"),
      meta: {
        title: "Registrieren",
      },
    },
    {
      path: "/setup",
      name: "Setup",
      component: () => import("../pages/setup.vue"),
      meta: {
        title: "Setup Verein",
      },
    },
    {
      path: "/anmelden",
      name: "Anmelden",
      component: () => import("../components/User/Signin.vue"),
      meta: {
        title: "Anmelden",
      },
    },
    {
      path: "/passwortvergessen",
      name: "Passwort vergessen",
      component: () => import("../components/User/Signin.vue"),
      meta: {
        title: "Passwort vergessen",
      },
    },
    {
      path: "/verifizieremail",
      name: "Mailadresse verifizieren",
      component: () => import("../components/User/VerifiziereMail.vue"),
      meta: {
        title: "Mailadresse verifizieren",
      },
    },
    {
      path: "/updateMail",
      name: "Mailadresse ändern",
      component: () => import("../components/User/UpdateMail.vue"),
      meta: {
        title: "Mailadresse ändern",
      },
    },
    {
      path: "/anleitungen",
      name: "Anleitungen",
      component: () => import("../components/User/Anleitungen.vue"),
      meta: {
        title: "Anleitungen",
      },
    },
  ],
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (to.meta.key === "modul") {
      const pageTitle = to.meta.title(to);
      document.title = `${pageTitle || "Korpodesk"}`;
    } else {
      document.title = `${to.meta.title || "Korpodesk"}`;
    }
    return { x: 0, y: 0 };
  },
});



// WEBPACK FOOTER //
// ./src/router/index.js